var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91306 18.8859L16.9132 10.8857L13.1133 7.08578L5.11312 15.086C5.00298 15.1962 4.92475 15.3343 4.88671 15.4854L4 19.999L8.51275 19.1123C8.66426 19.0744 8.80286 18.9961 8.91306 18.8859ZM19.4959 8.30307C19.8187 7.98019 20 7.54233 20 7.08578C20 6.62923 19.8187 6.19137 19.4959 5.86849L18.1305 4.50313C17.8077 4.18035 17.3698 3.99902 16.9132 3.99902C16.4567 3.99902 16.0188 4.18035 15.696 4.50313L14.3306 5.86849L18.1305 9.66843L19.4959 8.30307Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_803_7160)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#6B7280"
}));

function SvgEditgray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_803_7160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditgray);
export default __webpack_public_path__ + "static/media/editgray.dcc0266d.svg";
export { ForwardRef as ReactComponent };